const HeaderVideo = () => {
    return (
        <>
            <div className="w-full h-112 lg:h-96 relative mt-16 lg:mt-12">
                <video className="z-20" src="/media/PB_HeaderVideo.webm" poster="/media/header-video-placeholder.png" playsInline muted autoPlay loop></video>
            </div>
        </>
    );
};
export default HeaderVideo;